<template>
  <div class="catalog-cards">
    <template v-if="catalogsList.length">
      <!-- Sports selection -->
      <article class="sport-cards" v-if="showSportsCards">
        <label class="sidebar-option-title">Choose Sport</label>
        <div class="sport-cards-container">
          <ShowroomSportCard
            @selectSport="handleSelectedCatalog"
            :key="index + '-sport-card'"
            :id="sport"
            :sport="sport"
            v-for="(sport, index) in sportCatalogs"
            :selectedSports="selectedCatalogs"
            :forceShow="true"
            :forceShowName="true"
            :forceWorkWithoutSidebar="true"
          />
        </div>
      </article>

      <!-- Categories selection -->
      <article class="sport-cards" v-if="showCategoryCards">
        <label class="sidebar-option-title">Choose Category</label>
        <div class="sport-cards-container">
          <ShowroomSportCard
            @selectSport="handleSelectedCatalog"
            :key="index + '-sport-card'"
            :id="sport"
            :sport="sport"
            v-for="(sport, index) in categoryCatalogs"
            :selectedSports="selectedCatalogs"
            :forceShow="true"
            :forceShowName="true"
            :forceWorkWithoutSidebar="true"
          />
        </div>
      </article>
    </template>
    <div class="loading" v-else>
      <Loader />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import ShowroomSportCard from "@/components/Projects/Project/Sidebar/SportCard";
import Loader from "@/components/Utils/Loader";

export default {
  name: "CatalogCards",
  computed: {
    ...mapState("showroom", ["selectedCatalogs", "selectedCatalogsProducts", "showroomPath"]),
    //  ...mapState("catalog", ["catalogsData"]),
    ...mapGetters("catalog", ["catalogsList"]),

    showSportsCards() {
      return this.showroomPath === "school" || this.showroomPath === "team";
    },

    showCategoryCards() {
      return true;
    },

    sportCatalogs() {
      return this.catalogsList
        ? this.catalogsList.filter((c) => {
            return c.type === "sport";
          })
        : [];
    },

    categoryCatalogs() {
      return this.catalogsList
        ? this.catalogsList.filter((c) => {
            return c.type !== "sport";
          })
        : [];
    },

    isSchoolOrTeamInstitution() {
      return (
        this.selectedInstitution === "school" ||
        this.selectedInstitution === "team"
      );
    },
  },

  methods: {
    ...mapActions("showroom", [
      "fetchProductsFromCatalog",
      "setSelectedCatalogs",
    ]),

    async handleSelectedCatalog(payload) {
      const curedSelected = this.selectedCatalogs?.filter((c) => {
        return c && c.name != null;
      });
      console.log("selectedCatalogs", curedSelected);

      const findIndex = curedSelected?.find((c) => {
        return c.name === payload.name;
      });

      //this.$emit("updateSelectedCatalog", payload);

      if (findIndex) {
        console.log("found", payload, "in index " + findIndex);
        this.setSelectedCatalogs(
          curedSelected.filter((c) => {
            return c.name !== payload.name;
          })
        );
      } else {
        console.log("not found", payload);

        if (curedSelected != null) {
          this.setSelectedCatalogs([...curedSelected, payload]);
        } else {
          this.setSelectedCatalogs([payload]);
        }

        try {
          console.clear();
          console.log(this.selectedCatalogsProducts, payload.name);
          if (
            !this.selectedCatalogsProducts?.find((s) => {
              return s.catalogName === payload.name;
            })
          ) {
            this.$emit("fetchingLoading", true);
            await this.fetchProductsFromCatalog(payload.name);
          }
        } finally {
          this.$emit("fetchingLoading", false);
        }
      }
    },
  },
  components: {
    ShowroomSportCard,
    Loader,
  },
};
</script>

<style lang="scss" scoped>
#app {
  .loading {
    flex: 1;
    display: flex;
    justify-content: center;
  }
  .catalog-cards {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    v::deep .sport-card {
      margin-right: 0.5rem !important;
    }

    .sport-cards {
      .sport-cards-container {
        display: flex;
        flex-wrap: wrap;

        .sport-card {
          cursor: pointer;
          margin: 5px;
        }
      }      
    }
  }
}
</style>
